import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetHomeRooftopsQueryVariables = Types.Exact<{
  where: Types.Customers_Bool_Exp;
}>;


export type GetHomeRooftopsQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null, phone?: string | null, category?: string | null, config?: object | null, effective_config?: object | null, tier: string, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, phone?: string | null, latitude?: number | null, longitude?: number | null, timezone?: string | null, region_id?: number | null, region?: { __typename?: 'regions', id: number, name: string, status: string } | null } | null, organization?: { __typename?: 'organizations', id: number, name: string, config?: object | null } | null }> };


export const GetHomeRooftopsDocument = gql`
    query getHomeRooftops($where: customers_bool_exp!) {
  customers(where: $where, order_by: {name: asc}) {
    id
    name
    phone
    category
    config
    effective_config
    tier
    location {
      id
      name
      address
      phone
      latitude
      longitude
      timezone
      region_id
      region {
        id
        name
        status
      }
    }
    organization {
      id
      name
      config
    }
  }
}
    `;

/**
 * __useGetHomeRooftopsQuery__
 *
 * To run a query within a React component, call `useGetHomeRooftopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeRooftopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeRooftopsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetHomeRooftopsQuery(baseOptions: Apollo.QueryHookOptions<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables> & ({ variables: GetHomeRooftopsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>(GetHomeRooftopsDocument, options);
      }
export function useGetHomeRooftopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>(GetHomeRooftopsDocument, options);
        }
// @ts-ignore
export function useGetHomeRooftopsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>;
export function useGetHomeRooftopsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHomeRooftopsQuery | undefined, GetHomeRooftopsQueryVariables>;
export function useGetHomeRooftopsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>(GetHomeRooftopsDocument, options);
        }
export type GetHomeRooftopsQueryHookResult = ReturnType<typeof useGetHomeRooftopsQuery>;
export type GetHomeRooftopsLazyQueryHookResult = ReturnType<typeof useGetHomeRooftopsLazyQuery>;
export type GetHomeRooftopsSuspenseQueryHookResult = ReturnType<typeof useGetHomeRooftopsSuspenseQuery>;
export type GetHomeRooftopsQueryResult = Apollo.QueryResult<GetHomeRooftopsQuery, GetHomeRooftopsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/home/queries/getHomeRooftops.query.gql}
 */
export async function getHomeRooftops(
  variables: GetHomeRooftopsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetHomeRooftopsQuery['customers']>
export async function getHomeRooftops(
  variables: GetHomeRooftopsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetHomeRooftopsQuery>
export async function getHomeRooftops(
  variables: GetHomeRooftopsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetHomeRooftopsQuery['customers'] | GetHomeRooftopsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetHomeRooftopsQuery>(
    GetHomeRooftopsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}